import React from 'react'
import connect from "react-redux/es/connect/connect";
import Navbar from "./view/Navbar";

class NavbarContainer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loginVisible : false
        }
    };

    handleToggleLoginVisibility = () => {
        this.setState(state => ({
            ...state,
            loginVisible : !state.loginVisible}));
    };

    render() {
        return (
            <Navbar authenticated={this.props.authenticated}
                    username={this.props.username}
                    onToggleLoginVisibility = {this.handleToggleLoginVisibility}
                    loginVisible = {this.state.loginVisible}
                    onOrder = {this.props.onOrder}/>
        );
    }
}

function mapStateToProps(state) {
    return {
        authenticated : state.authentication.authenticated,
        username : state.authentication.username
    };
}


export default connect(mapStateToProps)(NavbarContainer);


// WEBPACK FOOTER //
// ./src/components/main/NavbarContainer.jsx